module.exports = __webpack_public_path__ + "assets/check_icon.9535c4a2.svg";